module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_5.75113ffb.pdf";